"use client";

import { c as _c } from "react/compiler-runtime";
import { HiOutlineLockClosed } from "react-icons/hi2";
import { formatDate } from "@/lib/format-data";
import { authService } from "@/services/auth-service";
interface AccessRestrictedScreenProps {
  until: Date;
}
export default function AccessRestrictedScreen(t0) {
  const $ = _c(9);
  const {
    until
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="rounded-full bg-status-warning-bg p-4"><HiOutlineLockClosed className="h-10 w-10 text-status-warning-text" /></div>;
    t2 = <h1 className="text-h1 text-foreground">Access Temporarily Restricted</h1>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== until) {
    t3 = formatDate(until, false, true);
    $[2] = until;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <p className="text-body-lg text-muted-foreground">Your access is on hold until{" "}<strong>{t3}</strong>. If you believe this is a mistake, please contact your administrator.</p>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <button onClick={_temp} className="mt-2 text-body text-muted-foreground underline-offset-4 hover:underline">Sign out</button>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <div className="flex h-full w-full items-center justify-center bg-background z-10 p-6"><div className="flex max-w-md flex-col items-center gap-4 text-center">{t1}{t2}{t4}{t5}</div></div>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
function _temp() {
  return authService.logout();
}